__webpack_require__.p = "/chatvia/vue/v-rtl/";